import type { CreateTweetMediaRequestType } from './createTweetMediaRequestType';

export interface CreateTweetMediaRequest {
  id: string;
  type: CreateTweetMediaRequestType;
  url: string;
}
